<template>
    <div>
        <div class="rockets">
            <RocketCard v-for="(rocket, index) in $store.getters.rockets" :key="index" :rocket="rocket"/>
        </div><!-- /.launches -->
    </div>
</template>

<script>

import RocketCard from '@/components/RocketCard'

export default {
    name: 'RocketList',
    components: {
        RocketCard,
    },
    data() {
        return {
            apiUrl: 'https://api.spacexdata.com/v3/rockets/'
        }
    },
    methods: {
        
    },
    created() {
        if(!this.$store.getters.rockets.length) {
            this.$store.dispatch('fetchRockets', this.apiUrl)
            console.log('went in rockets fetch from comp');
            
        }
    },
    mounted() {
        
    }
}
</script>

<style>

</style>

  